import httpCommon from "./http-common";

// Get all calendar events
const getAllEvents = (businessId: number) => {
  return httpCommon.get(`/v1/get/events/${businessId}`);
};

// Get event by ID
const getEvent = (eventId: string) => {
  return httpCommon.get(`/v1/get/event/${eventId}`);
};

// Get events for a specific date range
const getEventsByDateRange = (businessId: number, startDate: string, endDate: string) => {
  return httpCommon.get(`/v1/get/events/${businessId}/range`, {
    params: { startDate, endDate }
  });
};

// Create event
const createEvent = (businessId: number, data: any) => {
  return httpCommon.post(`/v1/add/event/${businessId}`, data);
};

// Update event
const updateEvent = (eventId: number, data: any) => {
  return httpCommon.put(`/v1/update/event/${eventId}`, data);
};

// Delete event
const deleteEvent = (eventId: number) => {
  return httpCommon.delete(`/v1/delete/event/${eventId}`);
};

// Get overlapping events
const getOverlappingEvents = (businessId: number, startDate: string, endDate: string) => {
  return httpCommon.get(`/v1/get/events/${businessId}/overlapping`, {
    params: { startDate, endDate }
  });
};

const CalendarService = {
  getAllEvents,
  getEvent,
  getEventsByDateRange,
  createEvent,
  updateEvent,
  deleteEvent,
  getOverlappingEvents
};

export default CalendarService; 